import type { LeaveQuery } from '@lemoment/shared';

/** Query-key factory for the leave domain. */
export const leaveKeys = {
  all: ['leaves'] as const,
  lists: () => [...leaveKeys.all, 'list'] as const,
  list: (query: LeaveQuery) => [...leaveKeys.lists(), query] as const,
  teamList: (query: { from: string; to: string }) =>
    [...leaveKeys.all, 'team', query] as const,
  me: () => ['me'] as const,
};
